export interface RequestGuard<T> {
  isStaleRequest: (key: T) => boolean;
  isSupersededRequest: (requestId: number) => boolean;
  startRequest: () => number;
}

export const createRequestGuard = <T>(
  getCurrentKey: () => T,
): RequestGuard<T> => {
  let latestRequestId = 0;

  const isStaleRequest = (key: T): boolean => getCurrentKey() !== key;

  const isSupersededRequest = (requestId: number): boolean =>
    requestId !== latestRequestId;

  const startRequest = (): number => ++latestRequestId;

  return { isStaleRequest, isSupersededRequest, startRequest };
};
